import { Language } from '../context/LanguageContext';
import { JewelleryCollectionId } from '../data/jewellery';
import { getLocalizedJewelleryItem, JewelleryCollectionItemView } from './jewelleryCollectionUtils';

export function getJewelleryItemView(
    language: Language,
    collectionId: JewelleryCollectionId,
    itemId: string
): JewelleryCollectionItemView | undefined {
    return getLocalizedJewelleryItem(collectionId, itemId, language);
}
